/* eslint-disable */
import { actions } from 'forms/rrf';
import {toast} from 'react-toastify';
import irelandApi from '../irelandApi';
import store, {history} from '../store';
import ToastMessage from '../components/common/toast-message';

const assembleLevel = (payLoad) => {
  return {...payLoad}
};

export const getLevels = (active = false) => (dispatch) => {
  dispatch({type: 'GET_LEVEL_LIST_PENDING'});
  const url = active ? '/api/admin/levels?active=true' : '/api/admin/levels';
  return irelandApi.get(url)
    .then((response) => {
      dispatch({type: 'GET_LEVEL_LIST_FULFILLED', payLoad: response.data});
    })
    .catch((error) => {
      dispatch({type: 'GET_LEVEL_LIST_REJECTED', payLoad: error.data});
    });
};

export const getLevel = id => (dispatch) => {
  dispatch({type: 'GET_LEVEL_PENDING'});
  const url = id ? `/api/admin/levels/${id}` : '/api/admin/levels/new';
  return irelandApi.get(url)
    .then((response) => {
      const data = {
        name: response.data.data.attributes.name || '',
        next_level: response.data.data.attributes['next-level'] || '',
        active: `${response.data.data.attributes.active}` || 'false'
      };

      store.dispatch(actions.load('deep.admin_level', data));
      dispatch({type: 'GET_LEVEL_FULFILLED', payLoad: response.data});
    })
    .catch((error) => {
      console.log(error);
      dispatch({type: 'GET_LEVEL_REJECTED', payLoad: error.data});
    });
};

export const saveLevel = payLoad => irelandApi.post('/api/admin/levels/', {level: payLoad})
  .then((response) => {
    toast.success(<ToastMessage iconStyle="success" message="Level saved successfully"/>);
    history.push('/admin/levels');
  })
  .catch((error) => {
    toast.error(<ToastMessage iconStyle="error" message="An error occurred during save level"/>);
    store.dispatch(actions.resetValidity('deep.admin_level'));
    const data = {
      ...error.response.data.errors
    };
    return Promise.reject(data);
  });

export const updateLevel = (id, payLoad) => irelandApi.patch(`/api/admin/levels/${id}`, {level: payLoad})
  .then((response) => {
    toast.success(<ToastMessage iconStyle="success" message="Level saved successfully"/>);
    history.push('/admin/levels');
  })
  .catch((error) => {
    toast.error(<ToastMessage iconStyle="error" message="An error occurred during save level"/>);
    store.dispatch(actions.resetValidity('deep.admin_level'));
    const data = {
      ...error.response.data.errors
    };
    return Promise.reject(data);
  });

export const deleteLevel = id => (dispatch) => {
  dispatch({type: 'DELETE_LEVEL_PENDING'});
  return irelandApi.delete(`/api/admin/levels/${id}`)
    .then(() => {
      toast.success(<ToastMessage iconStyle="success" message="Level has been deleted successfully"/>);
      dispatch({type: 'DELETE_LEVEL_FULFILLED', payLoad: id});
    })
    .catch((error) => {
      toast.error(<ToastMessage iconStyle="error" message="An error occured during level delete"/>);
      dispatch({type: 'DELETE_LEVEL_REJECTED', payLoad: error.data});
      const data = {
        ...error.response.data
      };
      return Promise.reject(data);
    });
};

export const setAsDefaultLevel = id => () => {
  return irelandApi.patch(`/api/admin/levels/${id}/set_default`)
    .then(() => {
      toast.success(<ToastMessage iconStyle="success" message="Level has been deleted successfully"/>);
      
      Promise.resolve();
    })
    .catch((error) => {
      toast.error(<ToastMessage iconStyle="error" message="An error occured during level delete"/>);
      const data = {
        ...error.response.data
      };
      return Promise.reject(data);
    });
};

